import * as React from 'react'

import { cn } from '@/lib/utils'

import { GeneralV1Footer } from './general-v1-footer'
import GeneralV1HomepageShell from './general-v1-homepage-shell'
import GeneralV1OverlayHeader from './general-v1-overlay-header'

interface GeneralV1PageFrameProps {
  children: React.ReactNode
  lang?: string
  showHeader?: boolean
  showFooter?: boolean
  className?: string
}

/** Shared General V1 chrome used by both the public page and Puck preview. */
export default function GeneralV1PageFrame({
  children,
  lang = 'ENG',
  showHeader = true,
  showFooter = true,
  className,
}: GeneralV1PageFrameProps) {
  return (
    <div className={cn('theme-general-v1', className)}>
      {showHeader && <GeneralV1OverlayHeader lang={lang} />}
      <GeneralV1HomepageShell>{children}</GeneralV1HomepageShell>
      {showFooter && <GeneralV1Footer />}
    </div>
  )
}
